/**
 * Delivery Areas page: accessible FAQ accordion toggle.
 */
(function () {
  document.querySelectorAll('.delivery-hub .collection-faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
    });
  });
})();
